import { ReactNode } from 'react';
import { Card } from './Card';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}

const EmptyState = ({ icon, title, description, action }: EmptyStateProps) => (
  <Card className="flex flex-col items-center justify-center gap-3 py-12 text-center">
    {icon && <div className="h-10 w-10 text-gray-400">{icon}</div>}
    <div>
      <p className="font-medium text-gray-800 dark:text-gray-100">{title}</p>
      {description && <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{description}</p>}
    </div>
    {action}
  </Card>
);

export default EmptyState;
